// Auto-generated file - do not edit manually
// Generated by: scripts/generate-exchange-data.js

export const ccxtExchanges = [
  "alpaca",
  "apex",
  "arkham",
  "ascendex",
  "backpack",
  "bequant",
  "bigone",
  "binance",
  "binancecoinm",
  "binanceus",
  "binanceusdm",
  "bingx",
  "bit2c",
  "bitbank",
  "bitbns",
  "bitfinex",
  "bitflyer",
  "bitget",
  "bithumb",
  "bitmart",
  "bitmex",
  "bitopro",
  "bitrue",
  "bitso",
  "bitstamp",
  "bitteam",
  "bittrade",
  "bitvavo",
  "blockchaincom",
  "blofin",
  "btcalpha",
  "btcbox",
  "btcmarkets",
  "btcturk",
  "bybit",
  "cex",
  "coinbase",
  "coinbaseadvanced",
  "coinbaseexchange",
  "coinbaseinternational",
  "coincatch",
  "coincheck",
  "coinex",
  "coinmate",
  "coinmetro",
  "coinone",
  "coinsph",
  "coinspot",
  "cryptocom",
  "cryptomus",
  "defx",
  "delta",
  "deribit",
  "derive",
  "digifinex",
  "exmo",
  "fmfwio",
  "foxbit",
  "gate",
  "gateio",
  "gemini",
  "hashkey",
  "hibachi",
  "hitbtc",
  "hollaex",
  "htx",
  "huobi",
  "hyperliquid",
  "independentreserve",
  "indodax",
  "kraken",
  "krakenfutures",
  "kucoin",
  "kucoinfutures",
  "latoken",
  "lbank",
  "luno",
  "mercado",
  "mexc",
  "modetrade",
  "myokx",
  "ndax",
  "novadax",
  "oceanex",
  "okx",
  "okxus",
  "onetrading",
  "oxfun",
  "p2b",
  "paradex",
  "paymium",
  "phemex",
  "poloniex",
  "probit",
  "timex",
  "tokocrypto",
  "toobit",
  "upbit",
  "wavesexchange",
  "whitebit",
  "woo",
  "woofipro",
  "xt",
  "yobit",
  "zaif",
  "zonda"
] as const;
